import { render } from "./ProfileEditForm.vue?vue&type=template&id=4be04869"
import script from "./ProfileEditForm.vue?vue&type=script&lang=js"
export * from "./ProfileEditForm.vue?vue&type=script&lang=js"
script.render = render

export default script